<template>
  <div class="mb-10">
    <v-card tile flat>
      <v-list-item dense class="px-0">
        <v-list-item-content class="pa-5">
          <v-row>
            <v-col class="py-0 my-1" cols="12" md="7">
              <v-list-item class="px-0">
                <v-list-item-content>
                  <h3>Daftar Kepala Sekolah Hasil Perhitungan Sebaran</h3>
                  <p class="body-2">
                    Daftar Kepala Sekolah hasil pemeringkatan dan perhitungan sebaran
                  </p>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" md="5">
              <v-row>
                <v-col cols="12" md="6">
                  <div><span class="caption grey--text">Status</span></div>
                  <v-chip :color="pspPeringkat.k_tahap_peringkat_psp >= 7 ? 'success' : 'orange'" text-color="white">
                    Daftar KS {{ pspPeringkat.k_tahap_peringkat_psp >= 7 ? 'Final' : 'Belum Final' }}
                  </v-chip>
                </v-col>
                <v-col cols="12" md="6">
                  <div><span class="white--text">Aksi Selanjutanya</span></div>
                  <v-btn color="primary" class="elevation-1" @click="onDetail('lolos')">
                    {{
                      pspPeringkat.k_tahap_peringkat_psp === 6 && $allow('psp-peringkat-dinas.ba-final')
                        ? 'Finalisasi Data'
                        : 'Lihat Detail'
                    }}
                  </v-btn>
                  <div
                    v-if="
                      [7, 9].includes(pspPeringkat.k_tahap_peringkat_psp) &&
                        $allow('psp-peringkat-dinas.ba-batal-final')
                    "
                    class="my-2"
                  >
                    <v-btn class="text-capitalize px-1 indigo--text body-2" text small @click="onBatalFinalisasi">
                      <v-icon left dark>
                        mdi-lock-open
                      </v-icon>
                      Batal finalisasi
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-divider class="my-5" />
          <v-row>
            <v-col class="py-0 my-1" cols="12" md="7">
              <v-list-item class="px-0">
                <v-list-item-content>
                  <h3>Dokumen Berita Acara Kepala Sekolah yang Lolos</h3>
                  <p class="body-2">
                    Merupakan file dokumen resmi yang sudah sesuai dengan peraturan dan tahap seleksi para Kepala
                    Sekolah. Dokumen dapat di unduh jika pada bagian <strong>Informasi Berita Acara</strong> sudah
                    lengkap. Pastikan Daftar Kepala Sekolah yang diterima <strong>sudah dinyatakan final</strong>
                  </p>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" md="5">
              <v-row>
                <v-col cols="12" md="6">
                  <div><span class="caption grey--text">Status</span></div>
                  <v-chip :color="pspPeringkat.file_ba ? 'success' : 'error'" text-color="white">
                    {{ pspPeringkat.file_ba ? 'Sudah Lengkap' : 'Belum Lengkap' }}
                  </v-chip>
                </v-col>
                <v-col cols="12" md="6">
                  <div><span class="white--text">Aksi Selanjutanya</span></div>
                  <v-btn
                    :disabled="pspPeringkat.k_tahap_peringkat_psp < 7"
                    depressed
                    color="primary"
                    class="elevation-1"
                    @click="onDetail('dokumen')"
                  >
                    Lihat Detail
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <template v-if="+pspPeringkat.is_revisi === 1">
            <v-divider class="my-5" />
            <v-row>
              <v-col class="py-0 my-1" cols="12" md="7">
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <h3>Dokumen Berita Acara Kepala Sekolah yang Lolos <span class="red--text">(REVISI)</span></h3>
                    <p class="body-2">
                      Merupakan file dokumen resmi yang sudah sesuai dengan peraturan dan tahap seleksi para Kepala
                      Sekolah. Dokumen dapat di unduh jika pada bagian <strong>Informasi Berita Acara</strong> sudah
                      lengkap.
                    </p>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="5">
                <v-row>
                  <v-col cols="12" md="6">
                    <div><span class="caption grey--text">Status</span></div>
                    <v-chip :color="pspPeringkat.file_ba_revisi ? 'success' : 'error'" text-color="white">
                      {{ pspPeringkat.file_ba_revisi ? 'Sudah Lengkap' : 'Belum Lengkap' }}
                    </v-chip>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div><span class="white--text">Aksi Selanjutanya</span></div>
                    <v-btn color="primary" class="elevation-1" @click="onDetail('revisi')">
                      Lihat Detail
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </v-list-item-content>
      </v-list-item>
    </v-card>
    <base-modal-full generalError ref="modal" :title="formulir.title" :mode="formulir.mode" @save="onSave">
      <component
        ref="component"
        :is="formulir.form"
        :initValue="formulir.init"
        :type="formulir.type"
        :mode="formulir.mode"
        @reload="reload"
      />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import DetailKasek from './detail/Kasek';
import DetailUnggah from './detail/Unggah';
export default {
  name: 'ba-index',
  components: { DetailKasek, DetailUnggah },
  data() {
    return {
      formulir: {},
    };
  },

  computed: {
    ...mapState('peringkat', {
      pspPeringkat: (state) => state.psp_peringkat || {},
    }),
  },

  methods: {
    ...mapActions('peringkat', ['detail', 'save']),

    reload() {
      this.$emit('reload');
    },

    onDetail(type) {
      const tahap = this.pspPeringkat.k_tahap_peringkat_psp || '';
      const configs = {
        dokumen: {
          component: 'DetailUnggah',
          title: 'Detail Berkas Berita Acara',
        },
        revisi: {
          component: 'DetailUnggah',
          title: 'Detail Berkas Berita Acara (Revisi)',
        },
        lolos: {
          component: 'DetailKasek',
          title: `${
            tahap === 6 && this.$allow('psp-peringkat-dinas.ba-final') ? 'Finalisasi' : ''
          } Daftar Kepala Sekolah yang Diterima dan Cadangan`,
          mode: tahap === 6 && this.$allow('psp-peringkat-dinas.ba-final') ? 'form' : 'detail',
        },
      };

      this.$set(this.formulir, 'mode', configs[type]['mode'] || 'detail');
      this.$set(this.formulir, 'type', type);
      this.$set(this.formulir, 'form', configs[type]['component']);
      this.$set(this.formulir, 'title', configs[type]['title']);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.component.reset();
      });
    },

    onSave() {
      if (this.formulir.form === 'DetailKasek') {
        this.onSaveFinalisasi();
      }
    },

    onSaveFinalisasi() {
      const msg = [
        '<span class="body-1 black--text">Apakah Anda yakin ingin menyatakan data kandidat telah <strong>FINAL</strong>?</span>',
        `<p class="body-2 black--text">Pastikan Anda telah melakukan pengecekan ulang untuk setiap data Kepala Sekolah sebelum dinyatakan FINAL</p>`,
      ].join('');

      this.$confirm(msg, 'Konfirmasi Batal Diskualifikasi').then(() => {
        this.save({ type: 'ba-final' }).then(() => {
          this.$refs.modal.dialog = false;
          this.$success('Berhasil disimpan');
          this.reload();
        });
      });
    },

    onBatalFinalisasi() {
      const msg = [
        '<span class="body-1 black--text">Apakah Anda yakin ingin membatalkan tahap Finalisasi Kandidat?</span>',
      ].join('');

      this.$confirm(msg, 'Konfirmasi Batal Finalisasi').then(() => {
        this.save({ type: 'ba-batal-final' }).then(() => {
          this.$refs.modal.dialog = false;
          this.$success('Berhasil dibatalkan');
          this.reload();
        });
      });
    },
  },
};
</script>

<style scoped></style>
